import { e as _objectSpread2 } from './_rollupPluginBabelHelpers-f5c57928.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import Select from './Select.js';
import Icon from './Icon.js';
import Popup from './Popup.js';
import { n as nodeOrStringProp } from './PropTypes-9aad034b.js';
import 'moment';
import './_commonjsHelpers-97e6d7b1.js';

function Paginator(props) {
  var currentPage = props.currentPage,
    totalPages = props.totalPages,
    onChangePage = props.onChangePage,
    onChangePageSize = props.onChangePageSize,
    pageSize = props.pageSize,
    pageSizeMessage = props.pageSizeMessage,
    referenceLabel = props.referenceLabel;
  var pagesNumber = [{
    value: 10,
    content: 10
  }, {
    value: 20,
    content: 20
  }, {
    value: 50,
    content: 50
  }, {
    value: 70,
    content: 70
  }, {
    value: 100,
    content: 100
  }];
  var pageNumberWithSizeSelected = function pageNumberWithSizeSelected() {
    return pagesNumber.map(function (item) {
      return item.value === pageSize ? _objectSpread2(_objectSpread2({}, item), {}, {
        selected: true
      }) : _objectSpread2({}, item);
    });
  };
  var handleOnChangePage = function handleOnChangePage(trigger, value) {
    if (trigger === 'first') {
      return onChangePage(1);
    }
    if (trigger === 'before') {
      return onChangePage(currentPage - 1);
    }
    if (trigger === 'next') {
      return onChangePage(currentPage + 1);
    }
    if (trigger === 'last') {
      return onChangePage(totalPages);
    }
    return onChangePage(value);
  };
  var onChangePageSizeHandler = function onChangePageSizeHandler(event) {
    var newPageSize = parseInt(event.target.value, 10);
    if (newPageSize !== pageSize) {
      onChangePageSize(newPageSize);
    }
  };
  var getArrayPagesNumber = function getArrayPagesNumber() {
    var newArray = [];
    for (var index = 1; index <= totalPages; index++) {
      newArray.push(index);
    }
    return newArray;
  };
  var arrayPages = getArrayPagesNumber();
  var PaginatorButton = function PaginatorButton(_ref) {
    var content = _ref.content,
      className = _ref.className,
      onClick = _ref.onClick,
      isHidden = _ref.isHidden,
      pageName = _ref.pageName;
    var pageButton = /*#__PURE__*/React__default.createElement("div", {
      className: "bf-paginator-button ".concat(className, " ").concat(isHidden ? 'is-hidden' : ''),
      onClick: !isHidden ? onClick : null
    }, content);
    return /*#__PURE__*/React__default.createElement("div", {
      className: "bf-paginator-button-wrapper"
    }, pageName && !isHidden ? /*#__PURE__*/React__default.createElement(Popup, {
      trigger: pageButton,
      content: pageName
    }) : pageButton);
  };
  PaginatorButton.defaultProps = {
    className: '',
    isHidden: false,
    pageName: ''
  };
  PaginatorButton.propTypes = {
    content: nodeOrStringProp.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    isHidden: PropTypes.bool,
    pageName: nodeOrStringProp
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-paginator-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-paginator-page-selection-wrapper"
  }, /*#__PURE__*/React__default.createElement(PaginatorButton, {
    className: "bf-paginator-first-page-selector",
    content: /*#__PURE__*/React__default.createElement(Icon, {
      name: "bf-icon-angle-double-left",
      size: "small"
    }),
    pageName: "First",
    onClick: function onClick() {
      return handleOnChangePage('first');
    },
    isHidden: currentPage < 3 || arrayPages.length < 3
  }), /*#__PURE__*/React__default.createElement(PaginatorButton, {
    className: "bf-paginator-prev-page-selector",
    content: /*#__PURE__*/React__default.createElement(Icon, {
      name: "bf-icon-angle-left",
      size: "small"
    }),
    pageName: "Prev",
    onClick: function onClick() {
      return handleOnChangePage('before');
    },
    isHidden: currentPage === 1
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-paginator-page-buttons-wrapper"
  }, arrayPages.map(function (elem) {
    return /*#__PURE__*/React__default.createElement(PaginatorButton, {
      className: "bf-paginator-page-selector ".concat(elem === currentPage ? 'is-active' : ''),
      content: elem,
      onClick: function onClick() {
        return handleOnChangePage('number', elem);
      },
      key: elem
    });
  })), /*#__PURE__*/React__default.createElement(PaginatorButton, {
    className: "bf-paginator-next-page-selector",
    content: /*#__PURE__*/React__default.createElement(Icon, {
      name: "bf-icon-angle-right",
      size: "small"
    }),
    pageName: "Next",
    onClick: function onClick() {
      return handleOnChangePage('next');
    },
    isHidden: currentPage === arrayPages.length
  }), /*#__PURE__*/React__default.createElement(PaginatorButton, {
    className: "bf-paginator-last-page-selector",
    content: /*#__PURE__*/React__default.createElement(Icon, {
      name: "bf-icon-angle-double-right",
      size: "small"
    }),
    pageName: "Last",
    onClick: function onClick() {
      return handleOnChangePage('last');
    },
    isHidden: currentPage > arrayPages.length - 2
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-paginator-page-reference-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-paginator-page-reference"
  }, referenceLabel), pagesNumber.length ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-pagination-page-size-selection-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-pagination-page-size-selection-label"
  }, pageSizeMessage), /*#__PURE__*/React__default.createElement(Select, {
    options: pageNumberWithSizeSelected(),
    onChange: onChangePageSizeHandler,
    className: "bf-pagination-page-size-selector"
  })) : null));
}
Paginator.propTypes = {
  /**
  Current Page Value
   */
  currentPage: PropTypes.number.isRequired,
  /**
  Total pages
   */
  totalPages: PropTypes.number.isRequired,
  /**
  Show the page size
   */
  pageSize: PropTypes.number.isRequired,
  /**
  Handle the paginator buttons
   */
  onChangePage: PropTypes.func.isRequired,
  /**
  Handle the paginator selector for page size
   */
  onChangePageSize: PropTypes.func.isRequired,
  /**
  Show the message for the selector
   */
  pageSizeMessage: nodeOrStringProp.isRequired,
  /**
  Show current paginator configuration
   */
  referenceLabel: nodeOrStringProp.isRequired
};

export default Paginator;
